import React from 'react'
import Lesson from './lesson'
import { ChapterEl } from '../elements/chapter'
import { H6, S05 } from '../../../../../../../../../../Styles/typography'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import { withRouter } from 'react-router-dom'
import LibraryBooksOutlinedIcon from '@material-ui/icons/LibraryBooksOutlined'
import useTime from '../../../../../../../../../../Helpers/CustomHooks/useTime'

const Chapter = ({
  match: {
    params: { chapterId: currentChapterId, lessonId: currentLessonId },
  },
  chapters,
  id: chapterId,
  title,
  lessons,
  index,
  disabled,
  startTime,
}) => {
  const now = useTime(5000)

  const currentChapter = chapters?.find(
    (chapter) => chapter.id === currentChapterId,
  )
  const currentLessonIndex = currentChapter?.lessons?.findIndex(
    (lesson) => lesson.id === currentLessonId,
  )

  return (
    <ChapterEl>
      <div className='title'>
        {startTime > now ? <LockOutlinedIcon /> : <LibraryBooksOutlinedIcon />}
        <div>
          <S05>Chapter {index}</S05>
          <H6>{title}</H6>
        </div>
      </div>

      <div className='lessons'>
        {lessons.map(({ id, ...lesson }, index) => (
          <Lesson
            key={id}
            id={id}
            chapterId={chapterId}
            {...lesson}
            disabled={disabled}
            active={
              currentChapterId === chapterId && index === currentLessonIndex
            }
          />
        ))}
      </div>
    </ChapterEl>
  )
}

export default withRouter(Chapter)
